import { useReactive } from "@supergrain/kernel/react"

/**
 * Whether a dialog should be in the tree at all: false until the first time it opens, true
 * forever after.
 *
 * A lesson renders dozens of modal trees that draw nothing — react-aria's ModalOverlay returns
 * null while closed — but re-render with their card. Almost none of them is ever opened.
 *
 * Mounting on first open rather than unmounting on close keeps this invisible: a dialog that
 * has been used stays mounted, so react-aria still runs its exit animation.
 */
export function useMountedOnceOpened(open: boolean): boolean {
  const state = useReactive({ hasOpened: open })
  if (open) state.hasOpened = true
  return state.hasOpened
}
